<template>
	<div>

		<div class="position-relative">
			<!-- shape Hero -->
			<section class="landing-section section-shaped my-0">
				<div class="shape shape-style-1 shape-skew">
					<!-- shape-default -->
					<span></span>
					<span></span>
					<span></span>
					<span></span>
					<span></span>
					<span></span>
					<span></span>
					<span></span>
					<span></span>
				</div>
				<div id="landing-frame" class="container shape-container d-flex">
					<div class="col px-0 landing">
						<div class="row landing">
							<div class="col-lg-5 order-med-1">
								<h1 class="display-3">Roho Network</h1>
								<p class="lead">A matchmaking platform service for social and environmental changemakers. Join the ecosystem, grow your business, change the world.</p>
								<base-button
									tag="a"
									icon="fa fa-sign-in"
									href="/volunteer/create"
									type="roho-blue">
									Join Now
								</base-button>
								<base-button
									tag="a"
									:outline="true"
									icon="fa fa-envelope"
									href="mailto:emily@rohonetwork.com"
									type="roho-blue">
									Contact
								</base-button>
								<!-- <p class="lead">
									Traditional supply chains are broken. Roho Network creates life-saving connections between manufacturers, makers, suppliers and heroes&#8212;half a mile or half a world apart. Whether you are established in your industry or are pivoting to join the fight, <strong>welcome to our global connection service</strong>. <br><br>

									Using AI technology and a global team of One Health specialists, Roho Network maximizes the impact of PPE distribution and paves the way for further sustainable economic development.
								</p> -->
							</div>
							<div class="col-md-7 order-md-2">
								<!-- <br><br><br>
								<h1 class="display-4 text-white">Human Development Index (HDI)</h1>
								<p class=" text-white">
									A country scores a higher HDI when the lifespan, the education level, and the gross national income GNI (PPP) per capita are higher.
								</p> -->
								<!-- <img src="/img/visuals/COVID-Countries_by_Human_Development_Index_(2019).png" class="img-fluid "> -->
							</div>
							<iframe class="video" src="https://www.youtube.com/embed/ji7cncxZung?modestbranding=0" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
						</div>
					</div>
				</div>
				<base-button
					class="explore-btn"
					tag="button"
					:outline="true"
					icon="fa fa-arrow-circle-down"
					href="/volunteer/create"
					type="roho-blue"
					v-scroll-to="{
						el: '#explore-start',
						offset: -50,
						duration: 500
					}">
					Explore
				</base-button>
			</section>
			<!-- 1st Hero Variation -->
		</div>

		<section class="section section-lg" id="explore-start">
			<div class="container">
				<div class="row row-grid align-items-center space-between">
					<div class="col-md-5 order-md-2">
						<img src="img/theme/mission.svg" class="img-fluid floating">
					</div>
					<div class="col-md-6 order-md-1">
						<div class="pr-md-5">
							<icon name="fa fa-rocket" class="mb-5" size="md" type="roho-blue" shadow
								  rounded></icon>
							<h3>Our Mission</h3>
							<p>
								Traditional supply chains are broken. Roho Network creates life-saving connections between manufacturers, makers, suppliers and heroes&#8212;half a mile or half a world apart. Whether you are established in your industry or are pivoting to join the fight, <strong>welcome to our global connection service</strong>. <br><br>
								Using AI technology and a global team of One Health specialists, Roho Network maximizes the impact of PPE distribution and paves the way for further sustainable economic development.
							</p>
							<!-- <ul class="list-unstyled mt-5">
								<li class="py-2">
									<div class="d-flex align-items-center">
										<badge type="roho-blue" circle class="mr-3" icon="fa fa-truck"></badge>
										<h6 class="mb-0">Global Network Of Suppliers</h6>
									</div>
								</li>
								<li class="py-2">
									<div class="d-flex align-items-center">
										<badge type="roho-yellow" circle class="mr-3" icon="fa fa-medkit"></badge>
										<h6 class="mb-0">Direct Connection To Medical Professionals</h6>
									</div>
								</li>
								<li class="py-2">
									<div class="d-flex align-items-center">
										<badge type="roho-red" circle class="mr-3" icon="fa fa-fighter-jet"></badge>
										<h6 class="mb-0">Lean And Mean - Bureaucracy Kills The Vibe</h6>
									</div>
								</li>
							</ul> -->
						</div>
					</div>
				</div>
			</div>
		</section>

		<section class="section section-lg pt-lg-0 mt-5">
			<div class="container">
				<div class="row justify-content-center">
					<div class="col-lg-12">
						<div class="row row-grid">
							<div class="col-lg-4">
								<card class="border-0" hover shadow body-classes="py-5">
									<icon name="fa fa-industry" type="roho-blue" rounded class="mb-4">
									</icon>
									<h6 class="text-roho-blue text-uppercase">I Have Supplies</h6>
									<p class="description mt-3"> Do you have PPE, tests or sanitation supplies?
									</p>
									<div>
										<badge type="roho-blue" rounded>Manufacturers</badge>
										<badge type="roho-blue" rounded>Suppliers</badge>
										<badge type="roho-blue" rounded>Small Businesses</badge>
										<badge type="roho-blue" rounded>Makers</badge>
									</div>
									<base-button tag="a" href="/supplier/create" type="roho-blue" class="mt-4">
										Become a supplier
									</base-button>
								</card>
							</div>
							<div class="col-lg-4">
								<card class="border-0" hover shadow body-classes="py-5">
									<icon name="fa fa-ambulance" type="roho-yellow" rounded class="mb-4">
									</icon>
									<h6 class="text-roho-yellow text-uppercase">I Need Supplies</h6>
									<p class="description mt-3">
										Get the resources you need to protect yourself and your community.
									</p>
									<div>
										<badge type="roho-yellow" rounded>hospitals</badge>
										<badge type="roho-yellow" rounded>clinics</badge>
										<badge type="roho-yellow" rounded>labs</badge>
										<badge type="roho-yellow" rounded>essential workers</badge>
									</div>
									<base-button tag="a" href="/buyer/create" type="roho-yellow" class="mt-4">
										Get Supplies
									</base-button>
								</card>
							</div>
							<div class="col-lg-4">
								<card class="border-0" hover shadow body-classes="py-5">
									<icon name="fa fa-user" type="roho-red" rounded class="mb-4">
									</icon>
									<h6 class="text-roho-red text-uppercase">I can help</h6>
									<p class="description mt-3">
										Help the heroes by donating your time, money, or resources.
									</p>
									<div>
										<badge type="roho-red" rounded>Foundations</badge>
										<badge type="roho-red" rounded>Businesses</badge>
										<badge type="roho-red" rounded>Amazing People</badge>
									</div>
									<base-button tag="a" href="/volunteer/create" type="roho-red" class="mt-4">
										Fight COVID-19
									</base-button>
								</card>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
		<section class="something-else section-center">
			<h4 class="mb-0 mr-5">Something else?</h4>
			<base-button tag="a"
					href="mailto:emily@rohonetwork.com"
					class="mb-0 mb-sm-0"
					:outline="true"
					type="info"
					icon="fa fa-envelope">
				Get In Touch
			</base-button>
		</section>
		<section class="section section-lg">
			<div class="container">
				<div class="row row-grid align-items-center space-between">
					<div class="col-md-5 order-md-2">
						<img src="img/theme/med.svg" class="img-fluid floating">
					</div>
					<div class="col-md-6 order-md-1">
						<div class="pr-md-5">
							<icon name="fa fa-handshake-o" class="mb-5" size="lg" type="roho-blue" shadow
								  rounded></icon>
							<h3>Do better together</h3>
							<p>
								Medical professionals and essential works all over the world are risking their lives so you can go back to normal as soon as possible. Help us help them help you!
							</p>
							<ul class="list-unstyled mt-5">
								<li class="py-2">
									<div class="d-flex align-items-center">
										<badge type="roho-blue" circle class="mr-3" icon="fa fa-truck"></badge>
										<h6 class="mb-0">Global Network Of Suppliers</h6>
									</div>
								</li>
								<li class="py-2">
									<div class="d-flex align-items-center">
										<badge type="roho-yellow" circle class="mr-3" icon="fa fa-medkit"></badge>
										<h6 class="mb-0">Direct Connection To Medical Professionals</h6>
									</div>
								</li>
								<li class="py-2">
									<div class="d-flex align-items-center">
										<badge type="roho-red" circle class="mr-3" icon="fa fa-fighter-jet"></badge>
										<h6 class="mb-0">Lean And Mean - Bureaucracy Kills The Vibe</h6>
									</div>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
		</section>
		<section class="section bg-secondary">
			<div class="container">
				<div class="row row-grid align-items-center">
					<div class="col-md-6">
						<div class="card bg-default shadow border-0">
							<img v-lazy="'img/theme/earth.jpg'" class="card-img-top">
							<blockquote class="card-blockquote">
								<svg preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 583 95"
									 class="svg-bg">
									<polygon points="0,52 583,95 0,95" class="fill-default"></polygon>
									<polygon points="0,42 583,95 683,0 0,95" opacity=".2" class="fill-default"></polygon>
								</svg>
								<h4 class="display-3 font-weight-bold text-white">A Global Network</h4>
								<p class="lead text-italic text-white">From large industrials to local small businesses, we bring everyone together and get stuff where it is actually needed.</p>
							</blockquote>
						</div>
					</div>
					<div class="col-md-6">
						<div class="pl-md-5">
							<icon name="fa fa-connectdevelop" class="mb-5" size="lg" type="roho-blue" shadow rounded></icon>

							<h3>We Are In This Together</h3>
							<p class="lead">A global crisis like the one we are currently facing requires that we cooperate beyond boundaries of state or culture.</p>
							<p>
								Whether you are a large industrial company gearing up to produce PPE, a small business with N95 masks still in stock or a private individual with a pack of gloves, every little thing can help save a life.
							</p>
							<p>
								Want to help institutions in your home town? We can do that! You'd rather go global and help wherever needed most? We do that too! You decide where you want to help.
							</p>
							<a href="/supplier/create" class="font-weight-bold text-roho-blue mt-5">
								Sign up now and help us aid the ones in need!
							</a>
						</div>
					</div>
				</div>
			</div>
		</section>
		<section id="scrollto" class="section section-lg">
			<div class="container">
				<div class="row justify-content-center text-center mb-lg">
					<div class="col-lg-8">
						<h2 class="display-3">Our Team</h2>
						<p class="lead text-muted">
							Take a closer look at the faces behind the whole operation. Our team consists entirely of volunteers and hackers, all the money made goes into supporting and growing the platform.
						</p>
					</div>
				</div>
				<div class="row">
					<div class="col-md-6 col-lg-3 mb-5 mb-lg-0" style="padding-bottom: 30px">
						<div class="px-4">
							<img v-lazy="'img/team/emily.png'"
								 class="rounded-circle img-center img-fluid shadow shadow-lg--hover"
								 style="width: 200px;">
							<div class="pt-4 text-center">
								<h5 class="title">
									<span class="d-block mb-1">Emily Sha</span>
									<small class="h6 text-muted">Co-Founder, Team Lead</small>
								</h5>
								<div class="mt-3">
									<base-button tag="a" href="https://www.linkedin.com/in/emily-sha-3487a91a/" type="roho-blue" icon="fa fa-linkedin" rounded
												 icon-only></base-button>
								</div>
							</div>
						</div>
					</div>
					<div class="col-md-6 col-lg-3 mb-5 mb-lg-0" style="padding-bottom: 30px">
						<div class="px-4">
							<img v-lazy="'img/team/lindsay.png'"
								 class="rounded-circle img-center img-fluid shadow shadow-lg--hover"
								 style="width: 200px;">
							<div class="pt-4 text-center">
								<h5 class="title">
									<span class="d-block mb-1">Lindsay Bryda</span>
									<small class="h6 text-muted">Co-Founder, Operations</small>
								</h5>
								<div class="mt-3">
									<base-button tag="a" href="https://www.linkedin.com/in/lindsaybryda/" type="roho-yellow" icon="fa fa-linkedin" rounded
												 icon-only></base-button>
								</div>
							</div>
						</div>
					</div>
					<div class="col-md-6 col-lg-3 mb-5 mb-lg-0" style="padding-bottom: 30px">
						<div class="px-4">
							<img v-lazy="'img/team/brooke.jpg'"
								 class="rounded-circle img-center img-fluid shadow shadow-lg--hover"
								 style="width: 200px;">
							<div class="pt-4 text-center">
								<h5 class="title">
									<span class="d-block mb-1">Brooke Swanson</span>
									<small class="h6 text-muted">Tech Lead</small>
								</h5>
								<div class="mt-3">
									<base-button tag="a" href="https://www.linkedin.com/in/brooke-swanson-b28bab111/" type="info" icon="fa fa-linkedin" rounded
												 icon-only></base-button>
								</div>
							</div>
						</div>
					</div>
					<div class="col-md-6 col-lg-3 mb-5 mb-lg-0" style="padding-bottom: 30px">
						<div class="px-4">
							<img v-lazy="'img/team/juan.png'"
								 class="rounded-circle img-center img-fluid shadow shadow-lg--hover"
								 style="width: 200px;">
							<div class="pt-4 text-center">
								<h5 class="title">
									<span class="d-block mb-1">Nathan Uchtmann</span>
									<small class="h6 text-muted">Lawyer & Physician</small>
								</h5>
								<div class="mt-3">
									<base-button tag="a" href="https://www.linkedin.com/in/nathaniel-uchtmann-277b7649/" type="roho-red" icon="fa fa-linkedin" rounded
												 icon-only></base-button>
								</div>
							</div>
						</div>
					</div>
					<div class="col-md-6 col-lg-3 mb-5 mb-lg-0" style="padding-bottom: 30px">
						<div class="px-4">
							<img v-lazy="'img/team/daniel.jpg'"
								 class="rounded-circle img-center img-fluid shadow shadow-lg--hover"
								 style="width: 200px;">
							<div class="pt-4 text-center">
								<h5 class="title">
									<span class="d-block mb-1">Daniel Putzer</span>
									<small class="h6 text-muted">Design & Software</small>
								</h5>
								<div class="mt-3">
									<base-button tag="a" href="https://www.linkedin.com/in/danielputzer/" type="roho-blue" icon="fa fa-linkedin" rounded
												 icon-only></base-button>
								</div>
							</div>
						</div>
					</div>
					<div class="col-md-6 col-lg-3 mb-5 mb-lg-0" style="padding-bottom: 30px">
						<div class="px-4">
							<img v-lazy="'img/team/nightingale.jpg'"
								 class="rounded-circle img-center img-fluid shadow shadow-lg--hover"
								 style="width: 200px;">
							<div class="pt-4 text-center">
								<h5 class="title">
									<span class="d-block mb-1">Nightingale Uchtmann</span>
									<small class="h6 text-muted">One Health Advocate</small>
								</h5>
								<div class="mt-3">
									<base-button tag="a" href="https://www.linkedin.com/in/nightingale-uchtmann-b18b0247/" type="roho-yellow" icon="fa fa-linkedin" rounded
												 icon-only></base-button>
								</div>
							</div>
						</div>
					</div>
					<div class="col-md-6 col-lg-3 mb-5 mb-lg-0" style="padding-bottom: 30px">
						<div class="px-4">
							<img v-lazy="'img/team/jesus.jpg'"
								 class="rounded-circle img-center img-fluid shadow shadow-lg--hover"
								 style="width: 200px;">
							<div class="pt-4 text-center">
								<h5 class="title">
									<span class="d-block mb-1">Jesús Puerta</span>
									<small class="h6 text-muted">Optimization</small>
								</h5>
								<div class="mt-3">
									<base-button tag="a" href="https://www.linkedin.com/in/jespestana/" type="info" icon="fa fa-linkedin" rounded
												 icon-only></base-button>
								</div>
							</div>
						</div>
					</div>
					<div class="col-md-6 col-lg-3 mb-5 mb-lg-0" style="padding-bottom: 30px">
						<div class="px-4">
							<img v-lazy="'img/team/stefania.jfif'"
								 class="rounded-circle img-center img-fluid shadow shadow-lg--hover"
								 style="width: 200px;">
							<div class="pt-4 text-center">
								<h5 class="title">
									<span class="d-block mb-1">Stefania Martello</span>
									<small class="h6 text-muted">Business Analyst & Strategy</small>
								</h5>
								<div class="mt-3">
									<base-button tag="a" href="https://www.linkedin.com/in/stefania-martello-31b3a3173/" type="roho-red" icon="fa fa-linkedin" rounded
												 icon-only></base-button>
								</div>
							</div>
						</div>
					</div>
					<div class="col-md-6 col-lg-3 mb-5 mb-lg-0 mt-5">
						<div class="px-4">
							<img v-lazy="'img/team/dolores.jpg'"
								 class="rounded-circle img-center img-fluid shadow shadow-lg--hover"
								 style="width: 200px;">
							<div class="pt-4 text-center">
								<h5 class="title">
									<span class="d-block mb-1">Dolores Zurdo</span>
									<small class="h6 text-muted">Quality Assurance</small>
								</h5>
								<div class="mt-3">
									<base-button tag="a" href="https://www.linkedin.com/in/doloreszurdo/" type="roho-blue" icon="fa fa-linkedin" rounded
												 icon-only></base-button>
								</div>
							</div>
						</div>
					</div>
					<!-- <div class="col-md-6 col-lg-3 mb-5 mb-lg-0 mt-5">
						<div class="px-4">
							<img v-lazy="'img/team/christian.jpg'"
								 class="rounded-circle img-center img-fluid shadow shadow-lg--hover"
								 style="width: 200px;">
							<div class="pt-4 text-center">
								<h5 class="title">
									<span class="d-block mb-1">Christian Shehata</span>
									<small class="h6 text-muted">Software Development</small>
								</h5>
								<div class="mt-3">
									<base-button tag="a" href="https://www.linkedin.com/in/christian-shehata-46285719a/" type="roho-yellow" icon="fa fa-linkedin" rounded
												 icon-only></base-button>
								</div>
							</div>
						</div>
					</div> -->
				</div>
			</div>
		</section>
		<section class="section section-lg pt-0">
			<div class="container">
				<card gradient="info"
					  no-body
					  shadow-size="lg"
					  class="border-0">
					<div class="p-5">
						<div class="row align-items-center">
							<div class="col-lg-8">
								<h3 class="text-white">Ready to hop on board?</h3>
								<p class="lead text-white mt-3">
									With a few clicks you'll be up and running, helping medical professionals get this crisis behind us.
								</p>
							</div>
							<div class="col-lg-3 ml-lg-auto">
								<base-button tag="a" href="/supplier/create"
											 type="white" block size="lg">
									Join Now
								</base-button>
							</div>
						</div>
					</div>
				</card>
			</div>
		</section>

	</div>
</template>

<script>
export default {
  name: "home",
  components: {}
};
</script>

<style lang="scss">
	#landing-frame {
		display: flex;
		align-items: center;
		height: 100vh !important;
	}

	.landing-section {
		display: flex;
		flex-direction: column;
	}

	.row.landing {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 0 15px 0 0;
		margin-top: 50px;
	}

	.space-between {
		justify-content: space-between;
	}

	.col.landing {
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.explore-btn {
		position: absolute;
		bottom: 0;
		margin: -100px auto 50px auto;
		border: none !important;
	}

	.lead {
		margin: 0 0 30px 0;
		font-size: 18px;
	}

	.video {
		width: 28vw;
		min-width: 450px;
		height: calc(28vw * 0.5625);
		min-height: calc(450px * 0.5625);
		border-radius: 10px;
		box-shadow: 0 0 40px 0px rgba($color: #444, $alpha: 0.1);
	}

	@media screen and (max-width: 990px) {
		.video {
			margin: 80px 15px 0 15px;
			width: 75vw;
			min-width: 0;
			height: calc(75vw * 0.5625);
			min-height: 0;
		}

		.explore-btn {
			margin: 50px 0 0 0 ;
			border: none !important;
		}

		.shape-container {
			padding-bottom: 0px !important;
		}

		.img-fluid {
			width: 80%;
		}
	}

	@media screen and (max-width: 576px) {

		#landing-frame {
			display: flex;
			align-items: center;
			height: 95vh !important;
		}

		.row.landing {
			padding: 0px;
			margin-top: 0px;
		}

		h1.display-3 {
			font-size: 30px;
		}

		p.lead {
			margin: 0 0 30px 0;
			font-size: 17px;
		}

		.video {
			margin: 60px 15px 0 15px;
			width: 90vw;
			min-width: 0;
			height: calc(90vw * 0.5625);
			min-height: 0;
		}

		.explore-btn {
			position: absolute;
			bottom: 0;
			margin: -75px auto 50px auto;
			border: none !important;
		}

		.shape-container {
			padding-top: 10em !important;
			padding-bottom: 0px !important;
		}

		#explore-start {
			padding-bottom: 0px !important;
		}

		.something-else {
			flex-direction: column;

			h4 {
				margin-right: 0 !important;
				margin-bottom: 15px !important;
			}
		}
	}
</style>
